import { Stack } from '@mui/system';
import { Divider, Box, Typography, useTheme } from '@mui/material';
import { AreaLoader } from '../../UI';
import AIChatMessage from '../AIChatMessage';
import { ChatMessages } from '../../../types/common';
import { useEffect, useRef } from 'react';

interface IAIChatTabProps {
  isLoading: boolean;
  placeholder: string;
  loaderText: string;
  messages: ChatMessages;
}

const AIChatTab: React.FC<IAIChatTabProps> = ({ messages, isLoading, placeholder, loaderText }) => {
  const theme = useTheme();
  const isPlaceholder = !isLoading && placeholder && messages.length === 0;
  const loaderRef = useRef<HTMLDivElement | null>(null);
  
  useEffect(() => {
    loaderRef?.current?.scrollTo({ top: loaderRef?.current?.scrollHeight, behavior: "smooth" });
  }, [isLoading, messages])

  return (
    <>
      {isPlaceholder && (
        <Stack sx={{ alignSelf: 'center', flex: 1, justifyContent: 'center' }}>
          <Typography variant={'h3'} sx={{ color: theme.custom.palette.primary.lightgray }} align="center">
            {placeholder}
          </Typography>
        </Stack>
      )}
      <Stack
        ref={loaderRef}
        sx={{
          maxHeight: 'calc(100vh - 230px)',
          overflowY: 'auto',
        }}
      >
        {messages.map((v, idx) => (
          <AIChatMessage key={idx} chatMessage={v.content} role={v.role} />
        ))}
        {isLoading && (
          <Box
            sx={{
              position: 'relative',
              height: '100px',
              pt: 20
            }}
          >
            <AreaLoader message={loaderText} small />
          </Box>
        )}
        <Box sx={{lineHeight: '50px'}}>&nbsp;</Box>
      </Stack>
    </>
  );
};

export default AIChatTab;
